
export const HOD_ROLE = {
  REGIONAL: 'ASSOCHAM Regional Head',
  STATE: 'ASSOCHAM State Head',
  SECRETARIAT: 'Council Secretariat',
  SENIOR_REGIONAL : 'Senior Regional Head',
  R_DIRECTOR: 'Regional Director'

};

export const statesData = {
  'gujarat': {
    name: 'Gujarat State Development Council',
    focusItems: ['Viksit Bharat 2047', 'Ease of Doing Business', 'Green Growth & Sustainable Development'],
    intro:
      "A focused ASSOCHAM platform strengthening Gujarat's industrial ecosystem through policy advocacy, investment engagement, MSME growth, infrastructure dialogue, and sustainable development.",
    why:
      "Located along India's western coast, Gujarat is one of the country's strongest contributors to manufacturing, MSMEs, exports and investment. The Council works to convert that strength into policy clarity, sector action and global competitiveness.",
    hod: {
      name: 'Vipul B Gajingwar',
      title: HOD_ROLE.REGIONAL,
      email: 'vipul.bg@assocham.com',
      phone: '+91 80104 72950',
    },
    overview: [
      "Located along the western coast of India, Gujarat is a state of immense historical, cultural, and economic significance. Often referred to as the \"Jewel of Western India,\" Gujarat has witnessed rapid economic development, remarkable industrial expansion, and has emerged as one of the country's leading contributors to the Indian economy. With a robust manufacturing base, thriving MSME ecosystem, world-class infrastructure, and a business-friendly environment, Gujarat continues to attract significant domestic and foreign investment.",
      "The ASSOCHAM Gujarat State Development Council serves as a leading Industry Policy Forum, working closely with the Central and State Governments to advance public policy, regulatory reforms, Ease of Doing Business, business competitiveness, MSME growth, infrastructure development, green growth, and sustainable development, while supporting the vision of Viksit Bharat 2047. Through policy advocacy, stakeholder engagement, and a wide spectrum of specialised services, the Council contributes to strengthening Gujarat's industrial and economic ecosystem.",
      "The Council works closely with the Government of Gujarat, industry, and other key stakeholders to address policy issues, enhance industrial efficiency, improve competitiveness, and expand business and investment opportunities across the state. It regularly organises conferences, seminars, business forums, and industry interactions while undertaking landmark initiatives across diverse sectors. Notably, the ASSOCHAM Gujarat State Development Council organised a high-level business delegation led by the then Hon'ble Chief Minister of Gujarat, Shri Vijay Rupani, to Uzbekistan, strengthening international business and trade relations.",
      "The Council is also an active participant in the prestigious Vibrant Gujarat Global Summit, organised by the Government of Gujarat, and works extensively with local chambers of commerce, industry associations, and government departments to foster collaboration and economic growth. Sectoral sub-committees have been constituted for Agro & Food Processing, Renewable Energy, Start-ups, Intellectual Property Rights (IPR), Taxation, IT/ITES & E-Commerce, MSMEs, and Pharmaceuticals to drive focused industry initiatives and sector-specific policy advocacy.",
      "Through continuous engagement with its members, policymakers, and industry stakeholders, the ASSOCHAM Gujarat State Development Council identifies emerging priorities, develops collaborative solutions, and drives initiatives that enhance industrial efficiency, innovation, investment opportunities, and the global competitiveness of industries in Gujarat.",
    ],
    sectors: [
      'Agro & Food Processing',
      'Renewable Energy',
      'Start-ups',
      'Intellectual Property Rights',
      'Taxation',
      'IT/ITES & E-Commerce',
      'MSMEs',
      'Pharmaceuticals',
    ],
    leadership: [
      { role: 'Chairman', name: 'Mr. Chintan Thaker', company: 'Welspun World', designation: 'Group President' },
      {
        role: 'Co-Chair',
        name: 'Mr. Jaimin Shah',
        company: 'DEV ITPL',
        designation: 'Corporate Affairs and Strategic Planning / MD & CEO',
      },
    ],
    initiatives: [
      'Stakeholder engagement for investment into Gujarat',
      'Industry academia sessions for stronger talent-industry linkages',
      'Industry inputs for Renewable Energy, Agri, Textile and Aatmnirbhar Gujarat policy',
      'Sectoral suggestions at council meetings with CM, Dy CM, ministers and senior government officers',
      'National Partner in Vibrant Gujarat Global Summit',
      'Lead partner for state-specific regional engagement, including Ceramic and BIS session at VGRC Rajkot',
      'Textile and chemical sector business promotion with MoU facilitation',
      "High-level business delegation to Uzbekistan led by then Hon'ble Chief Minister Shri Vijay Rupani",
    ],
    priorities: [
      'Position Gujarat as a high-confidence investment destination',
      'Deepen engagement with local and regional chambers',
      'Promote Dholera, GIFT City and other state priority projects',
    ],
  },

  'maharashtra': {
    name: 'Maharashtra State Council',
    focusItems: ['Viksit Bharat 2047', 'Ease of Doing Business', 'Industrial Infrastructure'],
    intro:
      'The ASSOCHAM Maharashtra State Council serves as a leading Industry Policy Forum, working closely with the Central and State Governments to promote public policy, regulatory reforms, Ease of Doing Business, business competitiveness, infrastructure development, innovation, and sustainable economic growth across the Western Region of India.',
    why:
      "Maharashtra is one of India's most urbanised states with a robust industrial ecosystem, anchored by Mumbai — the country's financial and commercial capital. Extensive road and port infrastructure make it one of the country's foremost investment destinations.",
    hod: {
      name: 'Robin Rosario',
      title: HOD_ROLE.STATE,
      email: 'robin.rosario@assocham.com',
      phone: '+91 91670 90555',
    },
    overview: [
      "Maharashtra is one of India's most urbanised states and possesses a robust industrial ecosystem that occupies a prominent position in the national economy. Widely recognised as India's economic powerhouse, the state is home to Mumbai—the country's financial and commercial capital. Supported by world-class infrastructure, an extensive road network spanning over 243,000 kilometres, national highways connecting major metropolitan cities, and two major ports along its 720-kilometre Arabian Sea coastline, Maharashtra continues to lead India's industrial and economic development. As one of the country's foremost investment destinations, the state attracts significant domestic and foreign investment across a diverse range of sectors.",
      "The ASSOCHAM Maharashtra State Council serves as a leading Industry Policy Forum, working closely with the Central and State Governments to promote public policy, regulatory reforms, Ease of Doing Business, business competitiveness, infrastructure development, innovation, and sustainable economic growth across the Western Region of India. Through policy advocacy, stakeholder engagement, and industry–government collaboration, the Council supports initiatives that strengthen Maharashtra's industrial ecosystem and contribute to the vision of Viksit Bharat 2047.",
      "The Council organises flagship summits, conferences, roundtables, and knowledge initiatives, including research papers and sectoral reports, to encourage dialogue on emerging industry trends and policy priorities. Through its sector-specific sub-committees, the Council actively engages with the Government of Maharashtra and industry stakeholders to address key policy issues, foster investment opportunities, and create a more competitive and business-friendly environment.",
      "ASSOCHAM works closely with government, industry, and other stakeholders to enhance operational efficiency, improve business competitiveness, expand domestic and global business opportunities, and support the state's continued leadership in India's economic and industrial growth.",
    ],
    sectors: ['Infrastructure Development', 'Innovation', 'Business Competitiveness', 'Investment Promotion'],
    leadership: [
      { role: 'Chairman', name: 'Mr. Milind Hardikar', company: 'Welspun', designation: 'Group Strategist' },
      { role: 'Co-Chair', name: 'Mr. Ramesh Krishnamurthy', company: 'VVF India Ltd', designation: 'CEO' },
    ],
    initiatives: [],
    priorities: [],
  },

  'odisha': {
    name: 'Odisha State Development Council',
    focusItems: ['Viksit Bharat 2047', 'Ease of Doing Business', 'MSME Growth'],
    intro:
      'The ASSOCHAM Odisha State Development Council serves as a leading Industry Policy Forum, working closely with the Central and State Governments, industry, and other stakeholders to advance public policy, regulatory reforms, business competitiveness, MSME growth, and investment opportunities across the state.',
    why:
      "Odisha is widely recognised for its rich reserves of minerals and metals, vibrant cultural heritage, and iconic temples, and has emerged as one of India's leading investment destinations.",
    hod: {
      name: 'Priyabrata Mishra',
      title: HOD_ROLE.STATE,
      email: 'priyabrata.mishra@assocham.com',
      phone: '+91 94379 46511',
    },
    overview: [
      "Odisha is widely recognised for its rich reserves of minerals and metals, vibrant cultural heritage, and iconic temples. The state has emerged as one of India's leading investment destinations, supported by its strong industrial base, abundant natural resources, and continued focus on Ease of Doing Business, infrastructure development, and sustainable economic growth.",
      "The ASSOCHAM Odisha State Development Council serves as a leading Industry Policy Forum, working closely with the Central and State Governments, industry, and other stakeholders to advance public policy, regulatory reforms, business competitiveness, MSME growth, and investment opportunities across the state. Through policy advocacy, stakeholder consultations, and industry–government collaboration, the Council actively submits representations on key industry issues and supports initiatives that contribute to Odisha's industrial development and align with the vision of Viksit Bharat 2047.",
    ],
    sectors: ['Minerals & Metals', 'MSMEs', 'Investment Promotion', 'Infrastructure Development'],
    leadership: [
      { role: 'Chairman', name: 'Mr. Pankaj Lochan Mohanty', company: 'MGM Minerals Ltd', designation: 'CMD' },
      { role: 'Co-Chair', name: 'Mr. Sunil Pandey', company: 'JSW', designation: 'VP' },
      { role: 'Co-Chair', name: 'Dr. Prabodh Mohanty', company: 'SNM Group', designation: 'Managing Director' },
    ],
    initiatives: [],
    priorities: [],
  },

  'north-east': {
    name: 'North East Development Council',
    focusItems: ['Viksit Bharat 2047', 'Regional Connectivity', 'Sustainable Development'],
    intro:
      'The ASSOCHAM North East Development Council serves as a leading Industry Policy Forum, working with the Central and State Governments to promote public policy, regulatory reforms, Ease of Doing Business, business competitiveness, infrastructure development, MSME growth, and sustainable economic development across the North-Eastern Region.',
    why:
      "India's North-Eastern Region is rapidly emerging as a strategic hub for economic growth, investment, and regional connectivity — rich in natural resources, biodiversity, and skilled human capital.",
    hod: {
      name: 'Bibhuti Dutta',
      title: HOD_ROLE.REGIONAL, // North East Regional Office — regional desk
      email: 'bibhuti.dutta@assocham.com',
      phone: '+91 98640 23255',
    },
    overview: [
      "India's North-Eastern Region is rapidly emerging as a strategic hub for economic growth, investment, and regional connectivity. Rich in natural resources, biodiversity, and skilled human capital, the region offers immense potential for industrial development, infrastructure expansion, tourism, trade, and cross-border economic cooperation with neighbouring countries.",
      "The ASSOCHAM North East Development Council serves as a leading Industry Policy Forum, working closely with the Central and State Governments to promote public policy, regulatory reforms, Ease of Doing Business, business competitiveness, infrastructure development, MSME growth, and sustainable economic development across the North-Eastern Region.",
      "The Council brings together policymakers, government agencies, industry leaders, infrastructure developers, investors, and other key stakeholders to foster collaboration, advance policy advocacy, and facilitate industry–government engagement. Through conferences, stakeholder consultations, knowledge initiatives, and strategic partnerships, the Council supports holistic and inclusive development, promotes investment opportunities, and contributes to the vision of Viksit Bharat 2047.",
    ],
    sectors: ['Natural Resources', 'Tourism', 'Cross-border Trade', 'Infrastructure Development'],
    leadership: [
      { role: 'Chairman', name: 'Mr. Joutishman Dutta', company: 'Down Town Group and University', designation: 'Trustee Director' },
    ],
    initiatives: [],
    priorities: [],
  },

  'haryana': {
    name: 'Haryana State Development Council',
    focusItems: ['Viksit Bharat 2047', 'Ease of Doing Business', 'Industrial Growth'],
    intro:
      'The ASSOCHAM Haryana State Development Council serves as a leading Industry Policy Forum, bringing together policymakers, government bodies, industry leaders, and other key stakeholders to strengthen collaboration and drive sustainable economic growth.',
    why:
      "Haryana is one of India's most developed states and a major contributor to the country's agriculture, manufacturing, industry, and commercial output, with strong hubs for engineering, automobiles, textiles and IT.",
    hod: {
      name: 'Bharti Sood',
      title: HOD_ROLE.SENIOR_REGIONAL, // Northern Region desk
      email: 'bharti.sood@assocham.com',
      phone: '+91 98187 15550',
    },
    overview: [
      "Haryana is one of India's most developed states and a major contributor to the country's agriculture, manufacturing, industry, and commercial output. Over the years, the state has achieved remarkable economic progress and established itself as a leading hub for engineering, automobiles, textiles, leather, information technology (IT), electronic hardware, and high-tech industries. Supported by robust infrastructure, strategic connectivity, and a business-friendly environment, Haryana continues to attract significant domestic and foreign investment.",
      "The ASSOCHAM Haryana State Development Council serves as a leading Industry Policy Forum, bringing together policymakers, government bodies, industry leaders, and other key stakeholders to strengthen collaboration and drive sustainable economic growth. Working closely with the Central and State Governments, the Council advances public policy, regulatory reforms, Ease of Doing Business, business competitiveness, MSME growth, infrastructure development, and investment opportunities across the state.",
      "Through policy advocacy, conferences, seminars, stakeholder consultations, and knowledge initiatives, the Council supports innovation, green growth, and industry–government collaboration while promoting a competitive and resilient industrial ecosystem. The Council remains committed to contributing to Haryana's continued development and supporting the vision of Viksit Bharat 2047.",
    ],
    sectors: ['Engineering', 'Automobiles', 'Textiles & Leather', 'IT & Electronic Hardware'],
    leadership: [
      { role: 'Chairman', name: 'Mr. Manav Gupta', company: 'Stylam Industries Limited', designation: 'Founder & CEO' },
      { role: 'Co-Chair', name: 'Mr. Jyoti Prakash Gadia', company: 'Resurgent India', designation: 'MD' },
    ],
    initiatives: [],
    priorities: [],
  },

  'punjab': {
    name: 'Punjab State Development Council',
    focusItems: ['Viksit Bharat 2047', 'Ease of Doing Business', 'MSME Growth'],
    intro:
      'The ASSOCHAM Punjab State Development Council serves as a leading Industry Policy Forum, working closely with the Central and State Governments to advance public policy, regulatory reforms, Ease of Doing Business, business competitiveness, MSME growth, infrastructure development, and investment opportunities across the state.',
    why:
      'Widely recognised as the "Land of Five Rivers," Punjab holds a prominent place in India\'s agricultural economy, with steady MSME growth and increasing opportunities across manufacturing, IT and services.',
    hod: {
      name: 'Bharti Sood',
      title: HOD_ROLE.SENIOR_REGIONAL, // Northern Region desk
      email: 'bharti.sood@assocham.com',
      phone: '+91 98187 15550',
    },
    overview: [
      "Widely recognised as the \"Land of Five Rivers,\" Punjab holds a prominent place in India's agricultural economy, rich cultural heritage, and historical legacy. Over the years, the state has witnessed steady MSME growth, industrial expansion, and increasing opportunities across the manufacturing, information technology (IT), and services sectors, contributing significantly to the Indian economy.",
      "The ASSOCHAM Punjab State Development Council serves as a leading Industry Policy Forum, working closely with the Central and State Governments to advance public policy, regulatory reforms, Ease of Doing Business, business competitiveness, MSME growth, infrastructure development, and investment opportunities across the state. Through policy advocacy, stakeholder engagement, and a wide range of specialised services, the Council supports a business-friendly environment and strengthens Punjab's industrial ecosystem.",
      "The Council works in the best interests of industry by providing policy recommendations and constructive inputs to the Government of Punjab on key sectoral issues. ASSOCHAM Punjab State Development Council remains committed to supporting pragmatic government initiatives that promote sustainable economic growth, industrial development, innovation, and the vision of Viksit Bharat 2047.",
    ],
    sectors: ['Agriculture', 'MSMEs', 'Information Technology', 'Manufacturing'],
    leadership: [
      { role: 'Chairman', name: 'Mr. Abhi Bansal', company: 'Saraswati Group of Companies', designation: 'Director' },
      { role: 'Co-Chair', name: 'Mr. Iqbal Cheema', company: 'Punjab Film City', designation: 'MD' },
    ],
    initiatives: [],
    priorities: [],
  },

  'uttar-pradesh': {
    name: 'Uttar Pradesh State Development Council',
    focusItems: ['Viksit Bharat 2047', 'Ease of Doing Business', 'Investment Promotion'],
    intro:
      'The ASSOCHAM Uttar Pradesh State Development Council serves as a leading Industry Policy Forum, working closely with the Central and State Governments, industry leaders, and other stakeholders to advance public policy, regulatory reforms, Ease of Doing Business, business competitiveness, MSME growth, infrastructure development, and sustainable economic development.',
    why:
      "With its rich natural resources, strategic location, and rapidly growing industrial ecosystem, Uttar Pradesh is India's third-largest state economy, contributing nearly 8% to national GDP, backed by a large working-age population.",
    hod: {
      name: 'Rajeev Dixit',
      title: HOD_ROLE.R_DIRECTOR, // Northern Region desk
      email: 'rajeev.dixit@assocham.com',
      phone: '+91 94150 23302',
    },
    overview: [
      "With its rich natural resources, strategic location, and rapidly growing industrial ecosystem, Uttar Pradesh is India's third-largest state economy, contributing nearly 8% to the national GDP. Home to the country's largest consumer market with a population of nearly 24 crore, the state also enjoys a significant demographic advantage, with around 56% of its population in the working-age group, positioning it as a key driver of India's future economic growth.",
      "Uttar Pradesh has emerged as one of India's leading investment destinations, supported by continuous improvements in Ease of Doing Business under the Business Reforms Action Plan of the Department for Promotion of Industry and Internal Trade (DPIIT), Ministry of Commerce & Industry, Government of India. The state's sustained progress in improving the investment climate has strengthened investor confidence and accelerated industrial and infrastructure development.",
      "The state offers significant investment opportunities across key sectors, including Food Processing, Handloom & Textiles, IT & ITES, Tourism, Defence & Aerospace, Civil Aviation, Renewable Energy, Films & Entertainment, Electronics Manufacturing, MSMEs, Pharmaceuticals, Logistics & Warehousing, Hospitality, and Exports.",
      "The ASSOCHAM Uttar Pradesh State Development Council serves as a leading Industry Policy Forum, working closely with the Central and State Governments, industry leaders, and other stakeholders to advance public policy, regulatory reforms, Ease of Doing Business, business competitiveness, MSME growth, infrastructure development, and sustainable economic development. Through policy advocacy, stakeholder consultations, capacity-building initiatives, research, conferences, and sector-specific engagements, the Council supports industry, facilitates knowledge exchange, and contributes to the state's socio-economic growth.",
      "The Council places special emphasis on promoting priority sectors such as Food Processing, Handloom & Textiles, IT & ITES, Tourism, Renewable Energy, Films & Entertainment, Electronics Manufacturing, MSMEs, Pharmaceuticals, Logistics & Warehousing, Hospitality, and Exports by strengthening industry–government collaboration and fostering investment, innovation, and business opportunities across Uttar Pradesh. The Council remains committed to supporting the vision of Viksit Bharat 2047 through inclusive and sustainable industrial development.",
    ],
    sectors: [
      'Food Processing',
      'Handloom & Textiles',
      'IT & ITES',
      'Tourism',
      'Defence & Aerospace',
      'Electronics Manufacturing',
      'MSMEs',
      'Pharmaceuticals',
    ],
    leadership: [
      { role: 'Chairman', name: 'Dr. Lalit Khaitan', company: 'Radico Khaitan Ltd', designation: 'CMD' },
      { role: 'Co-Chair', name: 'Mr. Vineet Nahata', company: 'Power Gilt', designation: 'Director' },
      {
        role: 'Co-Chair',
        name: 'Dr. Subi Chaturvedi',
        company: 'Corporate Chamber of India / Immobi',
        designation: 'SVP and Chief Corporate Affairs & Public Policy Officer',
      },
    ],
    initiatives: [],
    priorities: [],
  },

  'karnataka': {
    name: 'Karnataka State Development Council',
    focusItems: ['Viksit Bharat 2047', 'Ease of Doing Business', 'Innovation & Start-ups'],
    intro:
      'The ASSOCHAM Karnataka State Development Council serves as a leading Industry Policy Forum, working closely with the Central and State Governments to advance public policy, regulatory reforms, Ease of Doing Business, business competitiveness, MSME growth, infrastructure development, and sustainable economic growth.',
    why:
      "Located along the south-western coast, Karnataka is anchored by Bengaluru — India's technology and start-up capital — with a strong industrial base and a thriving innovation ecosystem.",
    hod: {
      name: 'Uma Nair',
      title: HOD_ROLE.REGIONAL,
      email: 'uma.nair@assocham.com',
      phone: '+91 90363 33975',
    },
    overview: [
      "Located along the south-western coast of India, Karnataka is one of the country's most dynamic and economically productive states. Recognised as a powerhouse of advanced manufacturing, information technology (IT), biotechnology, aerospace, and innovation, the state is anchored by Bengaluru—India's technology and start-up capital. Karnataka's strong industrial base, skilled workforce, world-class infrastructure, and thriving innovation ecosystem make it a leading destination for domestic and foreign investment.",
      "The ASSOCHAM Karnataka State Development Council serves as a leading Industry Policy Forum, working closely with the Central and State Governments to advance public policy, regulatory reforms, Ease of Doing Business, business competitiveness, MSME growth, infrastructure development, and sustainable economic growth. The Council places special emphasis on key sectors, including Automobiles & Auto Components, Energy & Environment, Agriculture & Food Processing, Electronics System Design & Manufacturing (ESDM), Healthcare & Medical Devices, Aerospace & Aviation, Information Technology (IT), ITES, and the Start-up ecosystem.",
      "Through policy advocacy, stakeholder consultations, conferences, research publications, capacity-building programmes, and industry–government collaboration, the Council promotes sectoral development, knowledge sharing, and innovation. ASSOCHAM Karnataka State Development Council remains committed to supporting its members, industry partners, and government by facilitating programmes, projects, publications, and strategic initiatives that strengthen Karnataka's socio-economic development and contribute to the vision of Viksit Bharat 2047.",
    ],
    sectors: [
      'Automobiles & Auto Components',
      'Energy & Environment',
      'Agriculture & Food Processing',
      'Electronics System Design & Manufacturing',
      'Healthcare & Medical Devices',
      'Aerospace & Aviation',
      'Information Technology',
      'Start-up Ecosystem',
    ],
    leadership: [
      { role: 'Chairman', name: 'Mr. Kishore Alva', company: 'Adani Group', designation: 'President & Executive Director' },
      {
        role: 'Co-Chair',
        name: 'Mr. Sanjay K. Handur',
        company: 'Aditya Birla Group',
        designation: 'Joint President - Corporate Affairs',
      },
      { role: 'Co-Chair', name: 'Dr. Anju Majeed', company: 'Sami Sabinsa Group', designation: 'Group Executive Chairperson' },
    ],
    initiatives: [],
    priorities: [],
  },

  'goa': {
    name: 'Goa State Development Council',
    focusItems: ['Viksit Bharat 2047', 'Ease of Doing Business', 'Sustainable Tourism'],
    intro:
      'The ASSOCHAM Goa State Development Council serves as a leading Industry Policy Forum, working closely with the Central and State Governments, industry, and other stakeholders to advance public policy, regulatory reforms, Ease of Doing Business, business competitiveness, MSME growth, and infrastructure development.',
    why:
      "Goa, India's smallest state, has the highest per capita Gross State Domestic Product among all Indian states, driven by a vibrant tourism industry and growing services sector.",
    hod: {
      name: 'Darshana Kossambe',
      title: HOD_ROLE.STATE,
      email: 'darshana.kossambe@assocham.com',
      phone: '+91 97637 88399',
    },
    overview: [
      "Goa, India's smallest state, has the highest per capita Gross State Domestic Product (GSDP) among all Indian states, reflecting its strong economic performance and high quality of infrastructure. Recognised for its vibrant tourism industry, strategic coastal location, and growing services sector, Goa offers significant opportunities for investment, entrepreneurship, and sustainable economic development.",
      "The ASSOCHAM Goa State Development Council serves as a leading Industry Policy Forum, working closely with the Central and State Governments, industry, and other stakeholders to advance public policy, regulatory reforms, Ease of Doing Business, business competitiveness, MSME growth, and infrastructure development. The Council is committed to addressing the challenges faced by local industries and businesses by advocating pragmatic solutions to issues such as regulatory compliance, licensing, approvals, and other policy-related matters.",
      "The Council actively organises flagship summits, conferences, research initiatives, and stakeholder consultations across priority sectors, including Agro & Food Processing, Fisheries, Tourism, Logistics, Start-ups, MSMEs, and IT/ITES. Through policy advocacy, industry–government collaboration, and knowledge-sharing initiatives, the Council promotes investment opportunities, sectoral development, innovation, and sustainable growth while contributing to the vision of Viksit Bharat 2047.",
    ],
    sectors: ['Agro & Food Processing', 'Fisheries', 'Tourism', 'Logistics', 'Start-ups', 'MSMEs', 'IT/ITES'],
    leadership: [
      { role: 'Chairman', name: 'Dr. Sagar Salgaocar', company: 'Geno Pharmaceuticals', designation: 'MD' },
      { role: 'Co-Chair', name: 'Mr. Mangirish Salelkar', company: 'UMANG Software Technologies Pvt Ltd', designation: 'CEO' },
    ],
    initiatives: [],
    priorities: [],
  },

  'keralam': {
    name: 'Kerala State Development Council',
    focusItems: ['Viksit Bharat 2047', 'Ease of Doing Business', 'Knowledge Economy'],
    intro:
      'The ASSOCHAM Kerala State Development Council serves as a leading Industry Policy Forum, working closely with the Central and State Governments to advance public policy, regulatory reforms, Ease of Doing Business, MSME growth, investment promotion, infrastructure development, and business competitiveness.',
    why:
      "Kerala's industrial landscape is transforming from traditional labour-intensive sectors to high-value, technology-driven industries, supported by a skilled workforce and strong tourism and healthcare sectors.",
    hod: {
      name: 'Uma Nair',
      title: HOD_ROLE.REGIONAL,
      email: 'uma.nair@assocham.com',
      phone: '+91 90363 33975',
    },
    overview: [
      "Located along the Malabar Coast in southern India, Kerala is globally renowned for its serene backwaters, traditional houseboats, rich cultural heritage, and authentic Ayurvedic wellness therapies. The state has emerged as a leading destination for tourism, healthcare, and knowledge-based services while continuing to strengthen its position as an attractive investment destination.",
      "Kerala's industrial landscape is undergoing a significant transformation, evolving from traditional labour-intensive sectors to high-value, technology-driven industries, innovation-led enterprises, and sustainable manufacturing. Supported by a skilled workforce, digital advancement, and a strong focus on sustainable development, the state continues to create new opportunities for economic growth and investment.",
      "The ASSOCHAM Kerala State Development Council serves as a leading Industry Policy Forum, working closely with the Central and State Governments to advance public policy, regulatory reforms, Ease of Doing Business, MSME growth, investment promotion, infrastructure development, and business competitiveness. The Council also promotes agri-value addition, tourism integration, the digital economy, sustainability, skilling, and industry–government collaboration to position Kerala as a high-value, knowledge-driven, and investment-friendly state.",
      "Through policy advocacy, stakeholder consultations, conferences, knowledge initiatives, and strategic partnerships, the Council serves as a dynamic platform for industry, government, and academia, supporting its members and partners while contributing to Kerala's sustainable development and the vision of Viksit Bharat 2047.",
    ],
    sectors: ['Tourism', 'Healthcare', 'Digital Economy', 'Agri Value Addition', 'Sustainability', 'Skilling'],
    leadership: [],
    initiatives: [],
    priorities: [],
  },

  'chandigarh': {
    name: 'Chandigarh Development Council',
    focusItems: ['Viksit Bharat 2047', 'Ease of Doing Business', 'Urban Development'],
    intro:
      'The ASSOCHAM Chandigarh Development Council serves as a leading Industry Policy Forum, working closely with the Union Territory Administration, the Central Government, industry, and other stakeholders to advance public policy, regulatory reforms, Ease of Doing Business, MSME growth, investment promotion, infrastructure development, and business competitiveness.',
    why:
      'Chandigarh, the shared capital of Punjab and Haryana, is internationally renowned for its architecture and urban planning, and is emerging as a hub for services, education, healthcare, IT and food processing.',
    hod: {
      name: 'Bharti Sood',
      title: HOD_ROLE.SENIOR_REGIONAL, // Northern Region desk
      email: 'bharti.sood@assocham.com',
      phone: '+91 98187 15550',
    },
    overview: [
      "Chandigarh, the shared capital of Punjab and Haryana, is also a Union Territory. One of India's earliest planned cities in the post-independence era, it is internationally renowned for its architecture, urban planning, and high quality of infrastructure. The Union Territory Administration is committed to fostering a progressive business environment, and the city is emerging as a hub for the services sector, education, healthcare, information technology (IT), food processing, and other high-growth industries. Supported by robust social, physical, and industrial infrastructure, excellent connectivity, and investor-friendly sectoral policies, Chandigarh offers significant investment opportunities.",
      "Recognising the city's growth potential, the ASSOCHAM Chandigarh Development Council serves as a leading Industry Policy Forum, working closely with the Union Territory Administration, the Central Government, industry, and other stakeholders to advance public policy, regulatory reforms, Ease of Doing Business, MSME growth, investment promotion, infrastructure development, and business competitiveness. Through policy advocacy and industry–government collaboration, the Council supports initiatives that strengthen Chandigarh's economic and industrial ecosystem.",
      "Through stakeholder consultations, conferences, knowledge initiatives, strategic partnerships, and sector-specific engagements, the Council serves as a dynamic platform for industry, government, academia, and civil society. It remains committed to supporting sustainable economic development, fostering innovation, expanding business opportunities, and contributing to the vision of Viksit Bharat 2047.",
    ],
    sectors: ['Services', 'Education', 'Healthcare', 'Information Technology', 'Food Processing'],
    leadership: [
      { role: 'Chairman', name: 'Mr. Rakesh Bhalla', company: 'SML Mahindra Limited', designation: 'Adviser' },
      { role: 'Co-Chair', name: 'Mr Drishmeet Singh Buttar', company: 'Healing Hospital Chandigarh', designation: 'Managing Partner' },
    ],
    initiatives: [],
    priorities: [],
  },

  'madhya-pradesh': {
    name: 'Madhya Pradesh State Development Council',
    focusItems: ['Viksit Bharat 2047', 'Ease of Doing Business', 'Investment Promotion'],
    intro:
      'The ASSOCHAM Madhya Pradesh State Development Council serves as a leading Industry Policy Forum, working closely with the Central and State Governments, industry, and other stakeholders to advance public policy, regulatory reforms, Ease of Doing Business, business competitiveness, MSME growth, infrastructure development, and investment promotion across the state.',
    why:
      "Madhya Pradesh, India's second-largest state by area, is a leading producer of minerals with agriculture as the backbone of its economy, and over 30% forest cover supporting a growing tourism sector.",
    // HOD yet to be assigned by the secretariat — page will show the default
    // ASSOCHAM secretariat contact (title: 'Council Secretariat').
    hod: null,
    overview: [
      "Madhya Pradesh, India's second-largest state by area, is one of the country's leading producers of minerals and contributes significantly to the national mining sector. Agriculture remains the backbone of the state's economy, making it a major contributor to India's agricultural output. Blessed with rich cultural heritage, historic landmarks, and over 30% forest cover, Madhya Pradesh has also emerged as a rapidly growing tourism destination.",
      "The state has consistently prioritised industrial development, establishing itself as a promising investment destination. Significant investments in infrastructure over recent years, coupled with continuous improvements in Ease of Doing Business, have strengthened Madhya Pradesh's industrial ecosystem and enhanced its attractiveness for domestic and foreign investors. With immense growth potential across tourism, logistics and warehousing, mining, manufacturing, agriculture, and allied industries, the state is well positioned to drive long-term economic growth and contribute significantly to the Indian economy.",
      "The ASSOCHAM Madhya Pradesh State Development Council serves as a leading Industry Policy Forum, working closely with the Central and State Governments, industry, and other stakeholders to advance public policy, regulatory reforms, Ease of Doing Business, business competitiveness, MSME growth, infrastructure development, and investment promotion across the state.",
      "The Council actively engages with the Government of Madhya Pradesh and industry on key policy issues while supporting the state's development agenda through policy advocacy, stakeholder consultations, flagship summits, conferences, research publications, and sector-specific initiatives. Through industry–government collaboration and knowledge-sharing platforms, the Council remains committed to strengthening the business ecosystem, expanding investment opportunities, and contributing to the vision of Viksit Bharat 2047.",
    ],
    sectors: ['Mining', 'Agriculture', 'Tourism', 'Logistics & Warehousing', 'Manufacturing'],
    leadership: [],
    initiatives: [],
    priorities: [],
  },
};

// Generic fallback — jis state ka apna initiatives/priorities/overview data nahi hai,
// usme yehi dikhega taaki har section state page par dikhe, kabhi khaali/hidden na ho.
export const defaultOverview = [
  "This State Development Council serves as a leading Industry Policy Forum, working closely with the Central and State Governments to advance public policy, regulatory reforms, Ease of Doing Business, business competitiveness, MSME growth, infrastructure development, green growth, and sustainable development, while supporting the vision of Viksit Bharat 2047.",
  "Through continuous engagement with its members, policymakers, and industry stakeholders, the Council identifies emerging priorities, develops collaborative solutions, and drives initiatives that enhance industrial efficiency, innovation, investment opportunities, and global competitiveness across the state.",
];

export const defaultInitiatives = [
  'Stakeholder engagement to promote investment into the state',
  'Industry-academia sessions for stronger talent-industry linkages',
  'Policy inputs for priority sectors and Ease of Doing Business reforms',
  'Sectoral recommendations shared with state government departments and ministers',
  'Participation in flagship state investment summits',
  'Business delegation and trade facilitation support',
];

export const defaultPriorities = [
  'Position the state as a high-confidence investment destination',
  'Deepen engagement with local and regional chambers',
  "Support promotion of the state's priority projects and sectors",
];

/* =====================================================================
   ASSOCHAM HoD (Head of Department / Secretariat Nodal Officer) DIRECTORY
   ---------------------------------------------------------------------
   Har state slug ke against uska ASSOCHAM HoD contact + ROLE TITLE.
   Ye alag export isliye rakha hai taaki jin states ka full content abhi
   statesData me nahi hai (e.g. rajasthan, telangana, tamil-nadu), unke
   State Page par bhi Contact Us section me sahi HoD ka naam, role,
   email aur phone dikh jaye.

   `title` = wo line jo Contact Us card ke top pe dikhti hai:
       'ASSOCHAM Regional Head'  -> Bharti Sood (Northern belt) + region slugs
       'ASSOCHAM State Head'     -> baaki sab HoD
   Kisi ek person ka label badalna ho? Sirf uske ek yahan `title` edit karo,
   poori app me automatically update ho jayega.

   Note: statesData[slug].hod agar defined hai to wo priority leta hai,
   warna yahan se uthaya jayega, aur last fallback defaultHod hai.
===================================================================== */
export const stateHods = {
  // ---------- South ----------
  'andhra-pradesh': {
    name: 'Macha Dinesh Babu',
    title: HOD_ROLE.REGIONAL,
    email: 'macha.dinesh@assocham.com',
    phone: '+91 80082 34556',
  },
  'telangana': {
    name: 'Macha Dinesh Babu',
    title: HOD_ROLE.REGIONAL,
    email: 'macha.dinesh@assocham.com',
    phone: '+91 80082 34556',
  },
  'karnataka': {
    name: 'Uma Nair',
    title: HOD_ROLE.REGIONAL,
    email: 'uma.nair@assocham.com',
    phone: '+91 90363 33975',
  },
  'tamil-nadu': {
    name: 'Uma Nair',
    title: HOD_ROLE.REGIONAL,
    email: 'uma.nair@assocham.com',
    phone: '+91 90363 33975',
  },
  'kerala': {
    name: 'Uma Nair',
    title: HOD_ROLE.REGIONAL,
    email: 'uma.nair@assocham.com',
    phone: '+91 90363 33975',
  },
  'pondicherry': {
    name: 'Uma Nair',
    title: HOD_ROLE.REGIONAL,
    email: 'uma.nair@assocham.com',
    phone: '+91 90363 33975',
  },

  // ---------- West ----------
  'gujarat': {
    name: 'Vipul B Gajingwar',
    title: HOD_ROLE.REGIONAL,
    email: 'vipul.bg@assocham.com',
    phone: '+91 80104 72950',
  },
  'maharashtra': {
    name: 'Robin Rosario',
    title: HOD_ROLE.STATE,
    email: 'robin.rosario@assocham.com',
    phone: '+91 91670 90555',
  },
  'goa': {
    name: 'Darshana Kossambe',
    title: HOD_ROLE.STATE,
    email: 'darshana.kossambe@assocham.com',
    phone: '+91 97637 88399',
  },

  // ---------- East ----------
  'odisha': {
    name: 'Priyabrata Mishra',
    title: HOD_ROLE.STATE,
    email: 'priyabrata.mishra@assocham.com',
    phone: '+91 94379 46511',
  },
  'west-bengal': {
    name: 'Ramit Sircar',
    title: HOD_ROLE.STATE,
    email: 'ramit.sircar@assocham.com',
    phone: '+91 98304 68951',
  },
  'eastern-region': {
    name: 'Ramit Sircar',
    title: HOD_ROLE.REGIONAL, // Eastern Regional Office
    email: 'ramit.sircar@assocham.com',
    phone: '+91 98304 68951',
  },

  // ---------- North East ----------
  'north-east': {
    name: 'Bibhuti Dutta',
    title: HOD_ROLE.REGIONAL, // North East Regional Office
    email: 'bibhuti.dutta@assocham.com',
    phone: '+91 98640 23255',
  },
  'assam': {
    name: 'Bibhuti Dutta',
    title: HOD_ROLE.STATE,
    email: 'bibhuti.dutta@assocham.com',
    phone: '+91 98640 23255',
  },

  // ---------- North ----------
  // Bharti Sood = ASSOCHAM Regional Head (Northern Region) — isliye unke
  // saare states me title REGIONAL hai, STATE nahi.
  'haryana': {
    name: 'Bharti Sood',
    title: HOD_ROLE.SENIOR_REGIONAL,
    email: 'bharti.sood@assocham.com',
    phone: '+91 98187 15550',
  },
  'punjab': {
    name: 'Bharti Sood',
    title: HOD_ROLE.SENIOR_REGIONAL,
    email: 'bharti.sood@assocham.com',
    phone: '+91 98187 15550',
  },
  'uttar-pradesh': {
    name: 'Bharti Sood',
    title: HOD_ROLE.SENIOR_REGIONAL,
    email: 'bharti.sood@assocham.com',
    phone: '+91 98187 15550',
  },
  'rajasthan': {
    name: 'Mr. Dinesh Mathur',
    title: HOD_ROLE.STATE,
    email: 'dinesh.mathur@assocham.com',
    phone: '+91 95874 95333',
  },
  'jammu-kashmir': {
    name: 'Bharti Sood',
    title: HOD_ROLE.SENIOR_REGIONAL,
    email: 'bharti.sood@assocham.com',
    phone: '+91 98187 15550',
  },
  'chandigarh': {
    name: 'Bharti Sood',
    title: HOD_ROLE.SENIOR_REGIONAL,
    email: 'bharti.sood@assocham.com',
    phone: '+91 98187 15550',
  },
  'delhi': {
    name: 'Bharti Sood',
    title: HOD_ROLE.SENIOR_REGIONAL,
    email: 'bharti.sood@assocham.com',
    phone: '+91 98187 15550',
  },
  'northern-region': {
    name: 'Bharti Sood',
    title: HOD_ROLE.SENIOR_REGIONAL,
    email: 'bharti.sood@assocham.com',
    phone: '+91 98187 15550',
  },
  'himachal-pradesh': {
    name: 'Bharti Sood',
    title: HOD_ROLE.SENIOR_REGIONAL,
    email: 'bharti.sood@assocham.com',
    phone: '+91 98187 15550',
  },
  'uttarakhand': {
    name: 'Bharti Sood',
    title: HOD_ROLE.SENIOR_REGIONAL,
    email: 'bharti.sood@assocham.com',
    phone: '+91 98187 15550',
  },
  'ladakh': {
    name: 'Bharti Sood',
    title: HOD_ROLE.SENIOR_REGIONAL,
    email: 'bharti.sood@assocham.com',
    phone: '+91 98187 15550',
  },

  // ---------- Council abhi allocate nahi hua / HoD TBC ----------
  // 'madhya-pradesh', 'bihar', 'chhattisgarh', 'central-region' — inke liye
  // defaultHod (ASSOCHAM Secretariat, title: 'Council Secretariat') dikhega.
};

// Jab kisi slug ka HoD assign nahi hua — ASSOCHAM ka central secretariat contact.
export const defaultHod = {
  name: 'ASSOCHAM Secretariat',
  title: HOD_ROLE.SECRETARIAT,
  subtitle: 'Central Secretariat — New Delhi',
  email: 'assocham@nic.in',
  phone: '011-46550555',
  isFallback: true,
};

/* ---------------------------------------------------------------------
   Role title resolve karne ke rules (sirf fallback ke liye — agar kisi
   entry me `title` likha hai to wahi jeetega).
     1. entry.title                        -> jo likha hai wahi
     2. naam REGIONAL_HEAD_NAMES me hai    -> ASSOCHAM Regional Head
     3. slug REGIONAL_SLUGS me hai         -> ASSOCHAM Regional Head
     4. warna                              -> ASSOCHAM State Head
--------------------------------------------------------------------- */
const REGIONAL_HEAD_NAMES = new Set([
  'Bharti Sood', // Northern Region
]);

const REGIONAL_SLUGS = new Set([
  'northern-region',
  'eastern-region',
  'western-region',
  'southern-region',
  'central-region',
  'north-east',
]);

function resolveHodTitle(entry, slug) {
  if (entry && entry.title) return entry.title;
  if (entry && entry.name && REGIONAL_HEAD_NAMES.has(entry.name)) return HOD_ROLE.REGIONAL;
  if (slug && REGIONAL_SLUGS.has(slug)) return HOD_ROLE.REGIONAL;
  return HOD_ROLE.STATE;
}

// Helper — slug se HoD nikalne ka single source of truth.
// Hamesha ek fully-populated object return karta hai, isliye UI me
// `hod.title`, `hod.name`, `hod.email`, `hod.phone` safely use kar sakte ho.
export function getStateHod(slug) {
  const own = statesData[slug]?.hod;
  const entry = (own && own.name ? own : null) || stateHods[slug] || null;

  // Koi HoD mapped nahi -> ASSOCHAM central secretariat.
  if (!entry) {
    return {
      ...defaultHod,
      slug,
      isFallback: true,
      isRegional: false,
    };
  }

  const title = resolveHodTitle(entry, slug);

  return {
    name: entry.name,
    title,                                   // 'ASSOCHAM Regional Head' | 'ASSOCHAM State Head'
    subtitle: entry.subtitle || '',          // optional; UI apna default laga leta hai
    email: entry.email || defaultHod.email,
    phone: entry.phone || defaultHod.phone,
    whatsapp: entry.whatsapp || entry.phone || defaultHod.phone,
    slug,
    isFallback: false,
    isRegional: /regional/i.test(title),     // UI badge ke liye (Regional Desk / State Desk)
  };
}

/* =====================================================================
   ASSOCHAM STATE / REGIONAL OFFICE ADDRESSES
   ---------------------------------------------------------------------
   Source: ASSOCHAM "Our Presence" — https://www.assocham.org/about-us.php
   Har slug ke against uska nearest ASSOCHAM state office. Contact Us section
   me yeh address dikhega, saath me "Get directions" Google Maps link.

   `lines` array me har line alag rakhi hai taaki UI me <br/> ke saath
   clean multi-line address render ho jaye.
   `mapQuery` sirf Google Maps search ke liye — flat single-line string.
===================================================================== */
export const stateOffices = {
  'gujarat': {
    label: 'ASSOCHAM State Office, Gujarat',
    city: 'Ahmedabad',
    lines: [
      '608, 6th Floor, SAKAR III,',
      'Opposite Old High Court, Income Tax Cross Road,',
      'Ashram Road, Ahmedabad,',
      'Gujarat – 380 014',
    ],
    phone: '079-2754 1728 / 2754 1876',
    mapQuery: 'SAKAR III, Ashram Road, Ahmedabad 380014',
  },
  'maharashtra': {
    label: 'ASSOCHAM State Office, Maharashtra',
    city: 'Mumbai',
    lines: [
      '315 Sprint, 3rd floor',
       'The Centrium, Phoenix MarketCity', 
       'Kamani, LBS Marg, Kurla West', 'Mumbai 400070, Maharashtra'
    ],
    mapQuery: 'The Centrium, LBS Marg, Kurla West, Mumbai 400070',
  },
  'odisha': {
    label: 'ASSOCHAM State Office, Odisha',
    city: 'Bhubaneswar',
    lines: [
      'Workloop Co-Office No. 316,',
      'Esplanade One Mall, Rasulgarh,',
      'Bhubaneswar, Odisha – 751 010',
    ],
    mapQuery: 'Esplanade One Mall, Rasulgarh, Bhubaneswar 751010',
  },
  'punjab': {
    label: 'ASSOCHAM State Office, Punjab',
    city: 'Mohali',
    lines: [
      'Punjab Innovation Mission, Kalkat Bhawan,',
      'Block-C, Aerocity, Airport Road,',
      'Sahibzada Ajit Singh Nagar,',
      'Mohali, Punjab – 140 603',
    ],
    mapQuery: 'Kalkat Bhawan, Aerocity, Mohali, Punjab 140603',
  },
  'uttar-pradesh': {
    label: 'ASSOCHAM State Office, Uttar Pradesh',
    city: 'Lucknow',
    lines: [
      '311-Parsvnath Planet Plaza', 
      'Vibhuti Khand, Gomti Nagar', 
      'Lucknow, Uttar Pradesh 226010'
    ],
    mapQuery: 'Summit Building, Vibhuti Khand, Gomti Nagar, Lucknow 226010',
  },
  'karnataka': {
    label: 'ASSOCHAM State Office, Karnataka',
    city: 'Bengaluru',
    lines: [
      'C/o Rainmakers Workspace, #213, 2nd Floor,',
      'Ramanashree Arcade, 18 M.G. Road,',
      'Bengaluru – 560 001',
    ],
    mapQuery: 'Ramanashree Arcade, MG Road, Bengaluru 560001',
  },
  'west-bengal': {
    label: 'ASSOCHAM State Office, West Bengal',
    city: 'Kolkata',
    lines: [
      'C/o Zioks, Room No. 118, 6th Floor,',
      'Tower II, Millennium City IT Park,',
      'DN 62, Sector V, Salt Lake,',
      'Kolkata – 700 091',
    ],
    mapQuery: 'Millennium City IT Park, Sector V, Salt Lake, Kolkata 700091',
  },
  'eastern-region': {
    label: 'ASSOCHAM Eastern Regional Office',
    city: 'Kolkata',
    lines: [
      'C/o Zioks, Room No. 118, 6th Floor,',
      'Tower II, Millennium City IT Park,',
      'DN 62, Sector V, Salt Lake,',
      'Kolkata – 700 091',
    ],
    mapQuery: 'Millennium City IT Park, Sector V, Salt Lake, Kolkata 700091',
  },
  'telangana': {
    label: 'ASSOCHAM State Office, Telangana',
    city: 'Hyderabad',
    lines: [
      'C/o AXIS Energy Group, Wing 2, Level 6,',
      'Block-D, Cyber Gateway,',
      'Madhapur, Hyderabad – 500 081',
    ],
    mapQuery: 'Cyber Gateway, Madhapur, Hyderabad 500081',
  },
  'andhra-pradesh': {
    label: 'ASSOCHAM State Office, Andhra Pradesh',
    city: 'Hyderabad',
    lines: [
      'C/o AXIS Energy Group, Wing 2, Level 6,',
      'Block-D, Cyber Gateway,',
      'Madhapur, Hyderabad – 500 081',
    ],
    mapQuery: 'Cyber Gateway, Madhapur, Hyderabad 500081',
  },
  'rajasthan': {
    label: 'ASSOCHAM State Office, Rajasthan',
    city: 'Jaipur',
    lines: [
      'Creware Business, 1st Floor,',
      '150/21, Shipra Path, Mansarovar,',
      'Jaipur, Rajasthan – 302 020',
    ],
    mapQuery: 'Shipra Path, Mansarovar, Jaipur 302020',
  },
  'goa': {
    label: 'ASSOCHAM State Office, Goa',
    city: 'Panaji',
    lines: [
      'Dempo Trade Centre, Ground Floor,',
      'MeWo Co-working, Next to Bank of India Building,',
      'Patto – Panaji, Goa – 403 001',
    ],
    mapQuery: 'Dempo Trade Centre, Patto Plaza, Panaji, Goa 403001',
  },
  // In offices ka address ASSOCHAM ne abhi publicly list nahi kiya — inke liye
  // HQ address dikhega, par city label sahi rahega.
  'tamil-nadu': {
    label: 'ASSOCHAM State Office, Tamil Nadu',
    city: 'Chennai',
    lines: [
      'No.6, Vanagaram Road, Ayanambakkam Chennai – 600095'
    ],
  },
  'kerala': {
    label: 'ASSOCHAM State Office, Kerala',
    city: 'Kochi',
    lines: [],
  },
  'north-east': {
    label: 'ASSOCHAM North East Regional Office',
    city: 'Guwahati',
    lines: [],
  },
  'assam': {
    label: 'ASSOCHAM North East Regional Office',
    city: 'Guwahati',
    lines: [],
  },
  // Northern belt — Chandigarh/Haryana/J&K/HP/Uttarakhand/Delhi ka kaam
  // Northern Region desk se hota hai.
  'chandigarh': {
    label: 'ASSOCHAM Northern Region Desk',
    city: 'Mohali / Chandigarh',
    lines: [
      'Punjab Innovation Mission, Kalkat Bhawan,',
      'Block-C, Aerocity, Airport Road,',
      'Sahibzada Ajit Singh Nagar,',
      'Mohali, Punjab – 140 603',
    ],
    mapQuery: 'Kalkat Bhawan, Aerocity, Mohali, Punjab 140603',
  },
  'haryana': {
    label: 'ASSOCHAM Northern Region Desk',
    city: 'New Delhi / NCR',
    lines: [],
  },
  'himachal-pradesh': {
    label: 'ASSOCHAM Northern Region Desk',
    city: 'New Delhi',
    lines: [],
  },
  'jammu-kashmir': {
    label: 'ASSOCHAM Northern Region Desk',
    city: 'Jammu',
    lines: [],
  },
  'ladakh': {
    label: 'ASSOCHAM Northern Region Desk',
    city: 'New Delhi',
    lines: [],
  },
  'uttarakhand': {
    label: 'ASSOCHAM Northern Region Desk',
    city: 'New Delhi',
    lines: [],
  },
};

/* =====================================================================
   ASSOCHAM HEADQUARTERS — universal fallback
   ---------------------------------------------------------------------
   Jis bhi state/council ka apna office address, phone ya email nahi hai,
   uske page par exactly yeh details dikhengi.
   `mapUrl` official Google Maps pin hai (lat 28.626824, lng 77.213067).
===================================================================== */
export const defaultOffice = {
  label: 'ASSOCHAM Headquarters',
  city: 'New Delhi',
  lines: [
    '4th Floor, YMCA Cultural Centre and Library Building,',
    '01, Jai Singh Road,',
    'New Delhi - 110001',
  ],
  addressLine: '4th Floor, YMCA Cultural Centre and Library Building, 01, Jai Singh Road, New Delhi - 110001',
  phone: '011-46550555',
  phoneHref: 'tel:01146550555',
  email: 'assocham@nic.in',
  mapUrl:
    'https://www.google.com/maps?ll=28.626824,77.213067&z=15&t=m&hl=en&gl=IN&mapclient=embed&cid=12074703925506796112',
  mapQuery: 'ASSOCHAM, Jai Singh Road, New Delhi 110001',
};

// Helper — slug se office address nikalne ka single source of truth.
// Priority: statesData[slug].office > stateOffices[slug] > defaultOffice (HQ)
// Jiska kuch nahi hai, usme poori tarah HQ ki details chali jaati hain.
export function getStateOffice(slug) {
  const own = statesData[slug]?.office || stateOffices[slug];

  // Na state office mapped hai, na address — seedha HQ.
  if (!own) return { ...defaultOffice, usingHqAddress: true };

  // Office mapped hai par address publish nahi hua — HQ ka address/phone/email
  // use karo, sirf label aur city apna rakho.
  if (!own.lines || own.lines.length === 0) {
    return {
      ...defaultOffice,
      label: own.label || defaultOffice.label,
      city: own.city || defaultOffice.city,
      usingHqAddress: true,
    };
  }

  // Apna address hai — jo field missing ho wo HQ se le lo.
  return {
    ...own,
    email: own.email || defaultOffice.email,
    phone: own.phone || defaultOffice.phone,
    mapQuery: own.mapQuery || defaultOffice.mapQuery,
    usingHqAddress: false,
  };
}

// Sirf naam ke liye — jab kisi state ka content abhi nahi likha, tab bhi
// nav se aane wale slug ka pretty title dikhane ke kaam aata hai.
export const stateNames = {
  'andhra-pradesh': 'Andhra Pradesh',
  'assam': 'Assam',
  'bihar': 'Bihar',
  'central-region': 'Central Region',
  'chandigarh': 'Chandigarh',
  'chhattisgarh': 'Chhattisgarh',
  'delhi': 'Delhi',
  'eastern-region': 'Eastern Region',
  'goa': 'Goa',
  'gujarat': 'Gujarat',
  'haryana': 'Haryana',
  'himachal-pradesh': 'Himachal Pradesh',
  'jammu-kashmir': 'Jammu & Kashmir',
  'karnataka': 'Karnataka',
  'Keralam': 'Keralam',
  'ladakh': 'Ladakh',
  'madhya-pradesh': 'Madhya Pradesh',
  'maharashtra': 'Maharashtra',
  'north-east': 'North East',
  'northern-region': 'Northern Region',
  'odisha': 'Odisha',
  'pondicherry': 'Pondicherry',
  'punjab': 'Punjab',
  'rajasthan': 'Rajasthan',
  'tamil-nadu': 'Tamil Nadu',
  'telangana': 'Telangana',
  'uttar-pradesh': 'Uttar Pradesh',
  'uttarakhand': 'Uttarakhand',
  'west-bengal': 'West Bengal',
};
